import { apiFetch } from './client';

// ──────────────────────────────────────────────────────────
// Types (mirror backend/src/routes/freeswitchAdmin.ts)
// ──────────────────────────────────────────────────────────

export type GatewayState =
  | 'REGED'
  | 'NOREG'
  | 'FAILED'
  | 'FAIL_WAIT'
  | 'UNREG'
  | 'TRYING'
  | 'DOWN'
  | 'UNKNOWN';

export type ProfileState = 'RUNNING' | 'DOWN' | 'UNKNOWN';

export interface GatewayStatusEntry {
  carrier_id: string;
  name: string;
  fs_name: string;
  state: GatewayState;
}

export interface FreeswitchStatus {
  freeswitch_up: boolean;
  external_profile_state: ProfileState;
  gateways: GatewayStatusEntry[];
}

export interface SyncResult {
  ok: boolean;
  gatewaysWritten: number;
  gatewaysUnchanged: number;
  gatewaysDeleted: number;
  aclWritten: boolean;
  profilePatched: boolean;
  rescan?: { ok: boolean; error?: string };
  reloadacl?: { ok: boolean; error?: string };
  errors: string[];
  durationMs: number;
}

// ──────────────────────────────────────────────────────────
// API client
// ──────────────────────────────────────────────────────────

export const freeswitch = {
  /**
   * GET /api/freeswitch/status — super_admin only.
   * Returns live FreeSWITCH state including all carrier gateway states.
   * Poll at a 10-second interval from the Carriers list page.
   */
  status: () => apiFetch<FreeswitchStatus>('/api/freeswitch/status'),

  /**
   * POST /api/freeswitch/sync-carriers — super_admin only.
   * Re-runs the full carrier syncer: writes gateway XMLs, ACL, reloads sofia.
   * Rate-limited to 10 requests per minute on the backend.
   */
  syncCarriers: () =>
    apiFetch<SyncResult>('/api/freeswitch/sync-carriers', { method: 'POST' }),
};
